const css = `.YBd7PW__tooltip{display:inline-block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tooltip":"YBd7PW__tooltip"};
